var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1578238228006,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2172,
    width: 14,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M917.452847 66.11786c10.292414 7.482415 14.502295 17.463744 12.631692 29.938869L810.328038 814.593689c-1.561565 9.041934-6.550183 16.060791-14.969946 21.049409-4.368494 2.494821-9.201569 3.741207-14.502295 3.741207-3.429099 0-7.1744-0.779759-11.227716-2.338255l-246.528789-100.57565L383.697357 889.439328c-5.615904 6.551206-12.941753 9.825786-21.988804 9.825786-4.365424 0-7.951089-0.623193-10.756995-1.870604-5.928013-2.182712-10.604522-5.848195-14.034645-10.992355-3.433192-5.148253-5.148253-10.840906-5.148253-17.076934L331.768661 657.880485 110.970906 567.597249c-11.540847-4.369517-17.776875-12.942777-18.712177-25.731034-0.935302-12.164041 4.053316-21.361517 14.969946-27.600615L885.64235 65.181535C896.558981 58.634422 907.158387 58.94653 917.452847 66.11786L917.452847 66.11786zM757.464039 767.345596l103.385649-618.895589L190.028473 535.319102l157.177785 64.088644 403.711691-298.925137L527.308149 673.318082 757.464039 767.345596zM757.464039 767.345596",
    "p-id": 2173,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.b39718226ba3794072b7eaf5aaec42b9.svg";
export { ForwardRef as ReactComponent };